import { render } from "./Game.vue?vue&type=template&id=9c3aab20"
import script from "./Game.vue?vue&type=script&lang=js"
export * from "./Game.vue?vue&type=script&lang=js"

import "./Game.vue?vue&type=style&index=0&id=9c3aab20&lang=scss"
script.render = render

export default script